import { Typography } from "@packages/ds";
import styled from "styled-components";

import CPageDescription from "Components/PageDescription";
import * as Accordion from "ds/Accordion";
import { Content as DsContent } from "ds/Dialog";

export const SectionHeader = styled(Accordion.SectionHeader)`
  font-size: 14px;
  line-height: 22px;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`;

export const Content = styled(DsContent)`
  display: block;
  width: 591px;
`;

export const NoteWrapper = styled.span`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 8px;
  margin-bottom: 32px;
`;

export const Heading = styled(Typography.Title)`
  margin-bottom: 80px;
  line-height: 32px;
`;

export const PageDescription = styled(CPageDescription)`
  padding-top: 0;
`;

export const Code = styled(Typography.Code)`
  margin: unset;
`;
